import { render, staticRenderFns } from "./edit-subpackage.vue?vue&type=template&id=7e65b6f1&"
import script from "./edit-subpackage.vue?vue&type=script&lang=js&"
export * from "./edit-subpackage.vue?vue&type=script&lang=js&"
import style0 from "./edit-subpackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports